import React, { useState, useEffect } from 'react';
import { Form } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import { getWidgetTypeProps } from '@/components/Widgets';
import OmniPicker from '@/components/OmniPicker';
import ButtonItemOptions from './ButtonItemOptions';
import WidgetOptionsForm from '../WidgetOptionsForm';
import WidgetOptionGroupPermissions from '../WidgetOptionGroupPermissions';
import { normalizeRepeatedItems, updateRepeatedItem } from '../repeatedWidgetItems';

const buttonWidgetDefaultProps = getWidgetTypeProps('Button');
const createDefaultButton = () => ({ ...(buttonWidgetDefaultProps.buttons?.[0] || {}) });

const getLegacyButtons = widgetProps => {
	const { text, buttonColor, textColor, onPress, position, source, size } = widgetProps;
	return [
		{
			...createDefaultButton(),
			text,
			buttonColor,
			textColor,
			onPress,
			position,
			source,
			size,
		},
	];
};

const ButtonWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		setOmniPicker,
		omniPicker,
		handlePickMedia,
		syncWidgetChange,
		handleGroupChange,
		targetKeys,
	} = props;
	const { amount = '1' } = widgetProps;
	const [buttonProps, setButtonProps] = useState([]);

	useEffect(() => {
		const normalizedButtons = normalizeRepeatedItems(
			widgetProps.buttons || getLegacyButtons(widgetProps),
			amount,
			createDefaultButton
		);
		setButtonProps(normalizedButtons);
	}, [widgetProps, amount]);

	const updateButton = (index, patch) => {
		setButtonProps(currentButtons => {
			const nextButtons = updateRepeatedItem(currentButtons, index, patch, createDefaultButton);
			syncWidgetChange({ ...widgetProps, buttons: nextButtons });
			return nextButtons;
		});
	};

	const updateButtonField = (index, key, value) => updateButton(index, { [key]: value });

	const handlePickOmniItem = (pickedLink, index) => {
		updateButtonField(index, 'onPress', pickedLink);
		setOmniPicker({ open: false, mediaPicker: false, from: '', index: null });
	};

	return (
		<>
			<WidgetOptionsForm initialValues={widgetToUpdate.props} handleChange={handleChange}>
				<Form.Item label="Number of Buttons in Row" name="amount">
					<Toggle toggleOptions={['1', '2']} />
				</Form.Item>
				{buttonProps.map((button, index) => (
					<ButtonItemOptions
						{...props}
						button={button}
						index={index}
						updateButton={updateButton}
						updateButtonField={updateButtonField}
						handlePickOmniItem={handlePickOmniItem}
						key={`button-item-option-${index}`}
					/>
				))}
				<WidgetOptionGroupPermissions
					event={event}
					handleGroupChange={handleGroupChange}
					targetKeys={targetKeys}
				/>
			</WidgetOptionsForm>
			<OmniPicker
				event={event}
				visible={omniPicker.open}
				onCancel={() => setOmniPicker({ open: false, mediaPicker: false, from: '', onPress: {} })}
				handlePickItem={pickedLink => handlePickOmniItem(pickedLink, omniPicker.index)}
				handlePickMedia={handlePickMedia}
				mediaPicker={omniPicker.mediaPicker}
				from={omniPicker.from}
				onPress={omniPicker.onPress}
			/>
		</>
	);
};

export default ButtonWidgetOptions;
